(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["treedix-lab-main-product"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('[data-tl-product-detail]');
  if (!root) return;
  const mainImageWrap = root.querySelector('[data-pdp-main-image]');
  root.querySelectorAll('[data-pdp-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const image = mainImageWrap ? mainImageWrap.querySelector('img') : null;
      if (image && thumb.dataset.imageUrl) {
        image.removeAttribute('srcset');
        image.src = thumb.dataset.imageUrl;
        image.alt = thumb.dataset.imageAlt || '';
      }
      root.querySelectorAll('[data-pdp-thumb]').forEach((item) => item.classList.toggle('is-active', item === thumb));
    });
  });
  const variantSelect = root.querySelector('[data-variant-select]');
  const variantInputs = Array.from(root.querySelectorAll('[data-variant-input]'));
  const stickyVariantInput = root.querySelector('[data-sticky-variant-input]');
  const quantityInputs = Array.from(root.querySelectorAll('[data-quantity-input]'));
  const stickyQuantityInput = root.querySelector('[data-sticky-quantity-input]');
  const priceTargets = Array.from(root.querySelectorAll('[data-product-price], [data-sticky-price]'));
  const addButtons = Array.from(root.querySelectorAll('[data-add-to-cart], [data-sticky-add]'));
  function syncVariant() {
    if (!variantSelect) return;
    const option = variantSelect.options[variantSelect.selectedIndex];
    if (!option) return;
    variantInputs.forEach((input) => { if (input !== variantSelect) input.value = option.value; });
    if (stickyVariantInput) stickyVariantInput.value = option.value;
    priceTargets.forEach((target) => { target.textContent = option.dataset.price || ''; });
    addButtons.forEach((button) => { button.disabled = option.dataset.available !== 'true'; });
  }
  function syncQuantity(source) {
    const value = source.value || '1';
    quantityInputs.forEach((input) => { if (input !== source) input.value = value; });
    if (stickyQuantityInput) stickyQuantityInput.value = value;
  }
  if (variantSelect) {
    variantSelect.addEventListener('change', syncVariant);
    syncVariant();
  }
  quantityInputs.forEach((input) => {
    input.addEventListener('input', () => syncQuantity(input));
    input.addEventListener('change', () => syncQuantity(input));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["treedix-lab-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSupportDownloads(root) {
      var scope = root && root.querySelector ? root : document;
      var sections = scope.querySelectorAll('[data-support-downloads-section]');

      sections.forEach(function (section) {
        if (section.dataset.supportDownloadsReady === 'true') return;
        section.dataset.supportDownloadsReady = 'true';

        var tabs = section.querySelectorAll('[data-support-filter]');
        var manuals = section.querySelectorAll('[data-support-manual]');
        var empty = section.querySelector('[data-support-empty]');

        function applyFilter(category) {
          var visibleCount = 0;

          manuals.forEach(function (manual) {
            var shouldShow = category === 'all' || manual.dataset.category === category;
            manual.hidden = !shouldShow;
            if (shouldShow) visibleCount += 1;
          });

          if (empty) {
            empty.hidden = visibleCount !== 0;
          }
        }

        tabs.forEach(function (tab) {
          tab.addEventListener('click', function () {
            tabs.forEach(function (otherTab) {
              otherTab.classList.remove('is-active');
              otherTab.setAttribute('aria-pressed', 'false');
            });

            tab.classList.add('is-active');
            tab.setAttribute('aria-pressed', 'true');
            applyFilter(tab.dataset.supportFilter || 'all');
          });
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initSupportDownloads(document);
      });
    } else {
      initSupportDownloads(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initSupportDownloads(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
